// Copyright (c) 2016 Deere & Company

import 'react-datepicker/dist/react-datepicker.css';
import './location-unknown-status-details.scss';
import React, {PropTypes} from 'react';
import CertifiedLetterSent from '../input-fields/certified-letter-sent';
import LastPersonalContact from '../input-fields/last-personal-contact';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';

const LocationUnknownStatusDetails = ({onItemChange, statusChangeRequest}) =>
    <section className='location-unknown-details'>

        <div className='status-change-item'>
            <LastPersonalContact
                onItemChange={onItemChange}
                statusChangeRequest={statusChangeRequest}
            />
        </div>

        <div className='status-change-item'>
            <CertifiedLetterSent
                onItemChange={onItemChange}
                statusChangeRequest={statusChangeRequest}
            />
        </div>

    </section>;

LocationUnknownStatusDetails.displayName = 'LocationUnknownStatusDetails';
LocationUnknownStatusDetails.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default LocationUnknownStatusDetails;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/additional-fields-views/location-unknown-status-details.js